import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled.div`
  position: relative;
`;
const Children = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  position: absolute;
  inset: 0;
  align-items: center;
`;

type Props = { border?: boolean; children?: ReactNode };

export const CollectionHexagon = ({ border, children }: Props) => {
  return (
    <Root>
      <svg
        width="57"
        height="66"
        viewBox="0 0 57 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M4.19702e-06 16.9917L1.39949e-06 48.9917L28 65L56 48.9917L56 16.9917L28 0.999998L4.19702e-06 16.9917Z"
            fill="#655400"
          />
          <mask
            id="mask0_8100_34727"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="56"
            height="64"
          >
            <path
              d="M4.19702e-06 16.9917L1.39949e-06 48.9917L28 65L56 48.9917L56 16.9917L28 0.999998L4.19702e-06 16.9917Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_8100_34727)">
            <path
              d="M-27.8159 32.8001L-27.8159 64.9331L0.16737 81.0079L28.1506 64.9331L28.1506 32.8001L0.167376 16.7253L-27.8159 32.8001Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M-37.8795 38.1031L-37.8795 70.2361L-9.87955 86.3109L18.1038 70.2361L18.1038 38.1031L-9.87954 22.0283L-37.8795 38.1031Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M-46.8731 43.3392L-46.8731 75.4722L-18.8898 91.547L9.09351 75.4722L9.09351 43.3392L-18.8898 27.2644L-46.8731 43.3392Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M84.0503 33.2491L84.0503 65.3987L56.067 81.4569L28.0837 65.3821L28.0837 33.2491L56.067 17.1743L84.0503 33.2491Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M94.0964 38.9011L94.0964 71.0341L66.1132 87.1089L38.1299 71.0341L38.1299 38.9011L66.1132 22.8263L94.0964 38.9011Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M103.106 44.1375L103.106 76.2705L75.1232 92.3453L47.1399 76.2705L47.1399 44.1375L75.1232 28.0627L103.106 44.1375Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M57.0032 -14.7261L29.2539 -31.1998L1.0366 -15.524L0.568533 16.609L28.3178 33.0828L56.5518 17.4069L57.0032 -14.7261Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M57.2036 -26.0631L29.4544 -42.5203L1.23704 -26.8444L0.768972 5.28856L28.5182 21.7623L56.7355 6.06986L57.2036 -26.0631Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              d="M57.2871 -36.4361L29.5379 -52.8933L1.32054 -37.2341L0.852468 -5.10109L28.6017 11.3727L56.819 -4.30316L57.2871 -36.4361Z"
              stroke="#FFFB68"
              strokeOpacity="0.16"
              strokeWidth="0.839345"
              strokeMiterlimit="10"
            />
            <path
              opacity="0.3"
              d="M56 17L28 33.0429L28 65L56 49L56 17Z"
              fill="url(#paint0_linear_8100_34727)"
            />
            <path
              opacity="0.3"
              d="M3.81596e-07 17L28 33.0434L28 65L-5.08584e-07 49L3.81596e-07 17Z"
              fill="url(#paint1_linear_8100_34727)"
            />
            <path
              opacity="0.3"
              d="M27.8839 1.00011L1.39877e-06 17L28 33.0001L55.5 17.0001L27.8839 1.00011Z"
              fill="url(#paint2_linear_8100_34727)"
            />
            <path
              d="M5.00168e-06 16.9917L2.20415e-06 48.9917L28 65L56 48.9917L56 16.9917L28 0.999999L5.00168e-06 16.9917Z"
              stroke="url(#paint3_linear_8100_34727)"
              strokeWidth="0.335738"
              strokeMiterlimit="10"
            />
          </g>
        </g>
        {!!border && (
          <path
            d="M0.500005 16.9917L0.500002 48.9917L28.5 65L56.5 48.9917L56.5 16.9917L28.5 0.999999L0.500005 16.9917Z"
            stroke="#FFFB68"
            strokeMiterlimit="10"
          />
        )}
        <defs>
          <linearGradient
            id="paint0_linear_8100_34727"
            x1="7.42546"
            y1="-939.231"
            x2="48.651"
            y2="38.8368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFFB68" stopOpacity="0" />
            <stop offset="1" stopColor="#F0CE1D" stopOpacity="0.6" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_8100_34727"
            x1="-12.5842"
            y1="19.1837"
            x2="17.8635"
            y2="44.3595"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFFB68" stopOpacity="0" />
            <stop offset="1" stopColor="#F0CE1D" stopOpacity="0.6" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_8100_34727"
            x1="32.735"
            y1="22.3476"
            x2="21.2986"
            y2="8.81969"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFFB68" stopOpacity="0" />
            <stop offset="1" stopColor="#F0CE1D" stopOpacity="0.6" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_8100_34727"
            x1="28.0001"
            y1="-857.27"
            x2="28.0001"
            y2="-857.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.19" stopColor="#FFFB68" />
            <stop offset="0.76" stopColor="#FFFB68" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
      {!!children && <Children>{children}</Children>}
    </Root>
  );
};
